import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined'
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(3),
    filter: `drop-shadow(0px 4px 10px theme.palette.secondary.main`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      marginRight: theme.spacing(2),
    },
    '& svg': {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      transform: 'rotate(-90deg)',
      [theme.breakpoints.down('xs')]: {
        width: theme.spacing(3),
        height: theme.spacing(3),
      },
    },
    '& path': {
      fill: theme.palette.secondary.contrastText,
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      filter: `drop-shadow(0px 4px 10px (theme.palette.secondary.main, 0.4))`,
    },
    '&:active': {
      backgroundColor: theme.palette.secondary.dark,
      filter: `drop-shadow(0px 4px 10px (theme.palette.secondary.dark, 0.4))`,
    },
  },
}))

const GoToTop = ({ _handleClick }) => {
  const classes = useStyles()
  const [showBackToTop, setShowBackToTop] = useState(false)

  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > window.innerHeight) {
        setShowBackToTop(true)
      } else {
        setShowBackToTop(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  if (showBackToTop) {
    return (
      <IconButton className={classes.root} aria-label="go to top" onClick={_handleClick}>
        <ExpandLessOutlinedIcon style={{ color: '#1A285D' }} />
      </IconButton>
    )
  } else return <div style={{ display: 'none' }}>11</div>
}

export default GoToTop
